import { EMPTY_LIST, EMPTY_STRING } from '../../constants/common'
import { getCounterValue } from '../Counter'

import { getLabels } from './Label.api'
import {
  LABEL_COMPACT_SIZE,
  LABEL_ENTITY_META,
  LABEL_PRIVACY_VALUE_PRIVATE,
  LABEL_PRIVACY_VALUE_PUBLIC,
} from './Label.constants'

function normalizeLabelEntityValue(value) {
  return value?.trim().toLowerCase()
}

function normalizeLabelPrivacyValue(value) {
  return value?.trim().toLowerCase()
}

export function isLabelCompactSize(height) {
  return height === LABEL_COMPACT_SIZE
}

export function getAvailableLabels(entity) {
  return params =>
    getLabels({
      ...params,
      ...(entity ? { entity } : null),
    })
}

export function toLabelSelectItem(item) {
  return {
    color: item.color,
    label: item.name,
    value: item.id,
  }
}

export function toLabelSelectItems(items, mapper = toLabelSelectItem) {
  return items.map(mapper)
}

export function getLabelColor(option) {
  return option.color
}

export function getLabelLabel(option) {
  return option.label
}

export function getLabelEntitySelectOptions(t) {
  return LABEL_ENTITY_META.map(({ Icon, labelKey, value }) => ({
    Icon,
    label: t(labelKey),
    value,
  }))
}

export function mapLabelEntityApiValueToFormValue(entityValue, t) {
  const v = normalizeLabelEntityValue(entityValue)
  const row = LABEL_ENTITY_META.find(x => x.value === v)

  return row
    ? { Icon: row.Icon, label: t(row.labelKey), value: row.value }
    : { label: entityValue, value: entityValue }
}

export function getLabelEntityCellDisplayText(entityValue, t) {
  const v = normalizeLabelEntityValue(entityValue)
  const row = LABEL_ENTITY_META.find(x => x.value === v)

  return row ? t(row.labelKey) : entityValue
}

export function getLabelPrivacyTableDisplayText(privacyValue, t) {
  const normalized = normalizeLabelPrivacyValue(privacyValue)

  if (normalized === LABEL_PRIVACY_VALUE_PRIVATE) {
    return t('Label.PrivacyFieldPrivateOptionKey')
  }

  if (normalized === LABEL_PRIVACY_VALUE_PUBLIC) {
    return t('Label.PrivacyFieldPublicOptionKey')
  }

  return privacyValue ?? EMPTY_STRING
}

export function canEditLabel(item) {
  return item?.permissions?.can_edit
}

export function canDeleteLabel(item) {
  return item?.permissions?.can_delete
}

export function getRemovedEntitiesAssignmentTotal({
  assignmentsCount,
  nextEntities,
  prevEntities,
}) {
  if (assignmentsCount && Array.isArray(prevEntities)) {
    const next = nextEntities ?? EMPTY_LIST
    const total = prevEntities.reduce((sum, entity) => {
      if (next.includes(entity)) {
        return sum
      }

      const count = Number(assignmentsCount[entity]) || 0

      return count > 0 ? sum + count : sum
    }, 0)

    return total > 0 ? getCounterValue(total) : null
  }

  return null
}
